import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { Tooltip, TooltipContent, TooltipTrigger } from "./index";

interface TooltipPlusButtonProps {
  tooltipText: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

export const TooltipPlusButton: React.FC<TooltipPlusButtonProps> = ({
  tooltipText,
  onClick,
  className = "text-red-3 w-6 h-6 transform transition-transform hover:scale-110 hover:cursor-pointer",
  disabled = false,
}) => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <FontAwesomeIcon
              width={20}
              height={20}
              icon={faCirclePlus}
              className={`${className} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={disabled ? undefined : onClick}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>{tooltipText}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipPlusButton;
